import { OnInit, TemplateRef } from '@angular/core';
var CsDropDownTogglerTemplatesComponent = /** @class */ (function () {
    function CsDropDownTogglerTemplatesComponent() {
    }
    CsDropDownTogglerTemplatesComponent.prototype.ngOnInit = function () {
    };
    return CsDropDownTogglerTemplatesComponent;
}());
export { CsDropDownTogglerTemplatesComponent };
